export const isUrlAllowed = (url: string): boolean => {
  if (/(tel:|mailto:|tg:\/\/|t\.me\/)/.test(url)) {
    return true
  }

  try {
    const parsedUrl = new URL(url)

    if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
      return false
    }

    const allowedDomains = [
      window.location.hostname,
      'mpi.mkb.ru',
      'appgallery.huawei.com',
      'apps.apple.com',
      'play.google.com',
      'rustore.ru',
      'mos.ru',
      'online.moek.ru'
    ]

    return allowedDomains.some(
      domain =>
        parsedUrl.hostname === domain ||
        parsedUrl.hostname.endsWith(`.${domain}`)
    )
  } catch {
    return false
  }
}
